import { h } from 'preact';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Filters = props => {
  const activeClass =
    props.currentAnimals.length > 0 || props.currentBrands.length > 0 || props.currentCategories.length > 0 || props.searchText
      ? 'c-shop-filters c-shop-filters--active'
      : 'c-shop-filters';
  const allAnimals = props.allAnimals;
  const allCategories = props.allCategories;
  const allBrands = props.allBrands;

  return (
    <div className={activeClass}>
      {activeClass === 'c-shop-filters c-shop-filters--active' ? (
        <div className="c-shop-filters__container">
          <div className="c-shop-filters__item c-shop-filters__item--close" onClick={props.handleReset}>
            <div class="c-shop-filters__item-content">
              Clear all filters
            </div>
          </div>

          {props.currentAnimals.map(item => {
            const currentCategory = allAnimals.filter(category => category.id == item);
            const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
            const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
            return <Item handleRemove={props.handleRemove} target="currentAnimals" item={currentCategoryName} id={currentCategoryID} />;
          })}
          {props.currentBrands.map(item => {
            const currentCategory = allBrands.filter(category => category.id == item);
            const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
            const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
            return <Item handleRemove={props.handleRemove} target="currentBrands" item={currentCategoryName} id={currentCategoryID} />;
          })}
          {props.currentCategories.map(item => {
            const currentCategory = allCategories.filter(category => category.id == item);
            const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
            const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
            return <Item handleRemove={props.handleRemove} target="currentCategories" item={currentCategoryName} id={currentCategoryID} />;
          })}
        </div>
      ) : null}
    </div>
  );
};

const Item = props => {
  return (
    <div className="c-shop-filters__item" onClick={props.handleRemove} data-target={props.target} data-name={props.item} data-id={props.id} >
      {props.label ? props.label : props.item}
      <svg className="c-icon c-shop-filters__icon">
        <use href={`#close`} xlinkHref={`#close`}></use>
      </svg>
    </div>
  );
};

export default Filters;


// WEBPACK FOOTER //
// ./src/js/shop/components/Filters.js